import { FormatAlignCenter, FormatAlignLeft, FormatAlignRight } from '@interhyp/platform-icons';
import { DropdownOption } from '@platform/elements';
import React, { useMemo } from 'react';
import { DropdownToolbarItem } from "./DropdownToolbarItem.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function TextAlignmentToolbarItem({
  active,
  action,
  title = 'Textausrichtung',
  disabled
}) {
  const previewIcon = useMemo(() => {
    if (active === 'CENTER') {
      return /*#__PURE__*/_jsx(FormatAlignCenter, {});
    } else if (active === 'RIGHT') {
      return /*#__PURE__*/_jsx(FormatAlignRight, {});
    }
    return /*#__PURE__*/_jsx(FormatAlignLeft, {});
  }, [active]);
  return /*#__PURE__*/_jsx(DropdownToolbarItem, {
    activeItem: active,
    title: title,
    useChildAsButton: true,
    disabled: disabled,
    options: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(DropdownOption, {
        label: "Left",
        onClick: () => action?.('LEFT'),
        active: active === 'LEFT',
        children: /*#__PURE__*/_jsx(FormatAlignLeft, {})
      }, "LEFT"), /*#__PURE__*/_jsx(DropdownOption, {
        label: "Center",
        onClick: () => action?.('CENTER'),
        active: active === 'CENTER',
        children: /*#__PURE__*/_jsx(FormatAlignCenter, {})
      }, "CENTER"), /*#__PURE__*/_jsx(DropdownOption, {
        label: "Right",
        onClick: () => action?.('RIGHT'),
        active: active === 'RIGHT',
        children: /*#__PURE__*/_jsx(FormatAlignRight, {})
      }, "RIGHT")]
    }),
    icon: previewIcon
  });
}